import "./FormSettings.scss";
import "../../../repository/infoPanelsInput/infoPanels.scss";
import { languageElements } from "./FormSettings-languageElements";
import LanguageElementsHandler from "../../../repository/languageElementsHandler/LanguageElementsHandler";
import InfoPanelsInput from "../../../repository/infoPanelsInput/InfoPanelsInput";
import useMain from "../../../common/MainContext";

export default function FormSettings(props) {
    const { language, loginData } = useMain();
    const languageElementsHandler = new LanguageElementsHandler(languageElements, language);

    return (
        <div className='form-settings'>
            <div className="form-settings-header">
                <h3>{languageElementsHandler.get('header-text')}</h3>
            </div>
            <div className="form-settings-body">
                <div className="form-settings-body-introduction">
                    <p>{languageElementsHandler.get('body-introduction')}</p>
                </div>
                <div className="form-settings-body-data-area">
                    <div className="info-panel">
                        <div className='info-panel-body'>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="row-description">
                                            {languageElementsHandler.get('field-name')}
                                        </td>
                                        <td colSpan={2}>
                                            <InfoPanelsInput type="text" value={loginData.tokenData.user.name} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="row-description">
                                            {languageElementsHandler.get('field-email')}
                                        </td>
                                        <td colSpan={2}>
                                            <InfoPanelsInput type="text" value={loginData.tokenData.user.email} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}